export function Brand({ inverse = false }: { inverse?: boolean }) {
  return <div className={`brand-lockup ${inverse ? 'inverse' : ''}`}><span>CO</span><div><strong>Pactlane</strong><small>Campaign Operations OS</small></div></div>
}

export function Metric({ label, value }: { label: string; value: number }) {
  return <div className="metric"><span>{label}</span><strong>{value}</strong></div>
}

export function Centered({ title }: { title: string }) {
  return <main className="auth-page"><section className="auth-card"><h1>{title}</h1></section></main>
}
